import CostCenter from '../components/costCenter.vue'

export default {
  components: {
    CostCenter,
  },
}
